import { CHARACTERS, ELEMENTS } from "./constants/cards";

const transformDna = function(cards) {
    if (cards.length <= 0) return [];

    let character;
    let strength;
    let defense;
    let stamina;
    let element;
    let level;
    let speed;
    let card;
    let dna;

    for (let i=0; i<cards.length; i++) {
        card = cards[i];
        
        if (!card.dna || card.dna == 0) {
            cards.splice(i, 1);
            break;
        }

        dna = card.dna.toString();
        strength = parseInt(dna.substr(0, 2));
        defense = parseInt(dna.substr(4, 2));
        stamina = parseInt(dna.substr(6, 2));
        speed = parseInt(dna.substr(2, 2));
        level = parseInt(card.level);
        element = dna.substr(8, 1);
        character = parseInt(dna.substr(9, 2));

        card.strength = strength;
        card.defense = defense;
        card.stamina = stamina;
        card.speed = speed;
        card.name = CHARACTERS[character].split('_').join(' ');
        card.element = ELEMENTS[element];
        card.imgUrl = "/static/card_" + CHARACTERS[character] + ".png";
        card.level = level;
        card.dna = dna;
    }

    return cards;
}

const getTeamScore = function(cards) {
    if (cards.length <= 0) return [];

    let card;
    let level;
    let speed;
    let defense;
    let stamina;
    let strength;
    let teamScore = 0;

    for (let i=0; i<cards.length; i++) {
        card = cards[i];
        
        strength = parseInt(card.strength);
        speed = parseInt(card.speed);
        defense = parseInt(card.defense);
        stamina = parseInt(card.stamina);
        level = parseInt(card.level);   
        
        teamScore += (level*5) + strength + speed + defense + stamina;
    }

    return teamScore;
}

const getCardScore = function(card) {

    if (!card) return;

    const strength = parseInt(card.strength);
    const speed = parseInt(card.speed);
    const stamina = parseInt(card.stamina);
    const defense = parseInt(card.defense);
    const level = parseInt(card.level) * 10;

    return strength + speed + stamina + defense + level;
}

export { transformDna, getTeamScore, getCardScore};


// WEBPACK FOOTER //
// ./src/util/transformDna.js